<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  components:{
   Vue3ChartJs 
  },  
  name: 'QuotationReport',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartConfig: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: 'Quotation Report'
    },
    chartKey: {
      type: [String, Number],
      default: 0
    }
  }
}
</script>

<template>
<div class="card flex-fill" v-if="chartData.total_quotations">
  <!-- <div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
  <h5 class="mb-2">{{ title }}</h5>
  </div> -->
  <div class="card-body pb-0">
  <div id="sales-income">
   <vue3-chart-js :key="chartKey" v-bind="{ ...chartConfig }" height="300" class="chartjs-chart"></vue3-chart-js>
  </div>
  </div>
  </div>    
</template>